import ProductAddToCart from './ProductAddToCart';
export default ProductAddToCart;
